import type { QueryClient } from '@tanstack/react-query'

/** Chave do contador do menu Chamados. Própria: dividir chave com o `getInbox`
 *  paginado do Header fazia o menu parar na página de 5 (review da Onda 3). */
export const CHAVE_PENDENCIAS_DO_MENU = ['chamados-menu-pendencias'] as const

/**
 * Invalidação única depois de QUALQUER mutação que muda o estado de um chamado
 * (transição, finalizar, validar, aceite, reatribuir, arrastar no quadro, criar):
 * a lista, a Entrada, o sino do Header e o número do menu. Um helper só porque a
 * chave do menu ficou esquecida em quatro mutações (review da Onda 3, volta 2);
 * `components/chamados/__tests__/invalidarPendencias.test.tsx` reprova quem invalida
 * `['chamados']` sem passar por aqui. (`['workflow', ...]` não entra: nenhum `useQuery`
 * montado usa essa chave — o KanbanBoard não é renderizado em tela nenhuma.)
 *
 * Módulo separado de `api/chamados.ts` de propósito: testes que mockam aquele
 * módulo inteiro não apagam este.
 */
export function invalidarPendenciasDoChamado(queryClient: QueryClient): void {
  queryClient.invalidateQueries({ queryKey: ['chamados'] })
  queryClient.invalidateQueries({ queryKey: ['chamados-inbox'] })
  queryClient.invalidateQueries({ queryKey: ['chamados-inbox-count'] })
  queryClient.invalidateQueries({ queryKey: CHAVE_PENDENCIAS_DO_MENU })
}
